"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.find-index");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _moment = _interopRequireDefault(require("moment"));

var _vuedraggable = _interopRequireDefault(require("vuedraggable"));

var _elementUi = require("element-ui");

var _lastMileDelivery = require("@/mixins/last-mile-delivery/last-mile-delivery");

var _truckSummaryModal = _interopRequireDefault(require("../truck-summary-modal/truck-summary-modal.vue"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDTruckSummaryComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDTruckSummaryComponent, _Mixins);

  var _super = _createSuper(LMDTruckSummaryComponent);

  function LMDTruckSummaryComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDTruckSummaryComponent);
    _this = _super.apply(this, arguments);
    _this.isReorderingEnabled = true;
    _this.currentTruck = {};
    _this.currentDriver = null;
    _this.truckInPlan = {};
    _this.dragOptions = {
      group: 'masterpointId',
      ghostClass: 'ghost',
      animation: 300,
      // disabled: false,
      filter: '.disabled',
      onMove: function onMove(e) {
        return !e.related.classList.contains('disabled');
      }
    };
    _this.isModalVisible = false;
    _this.routeDetails = null;
    _this.routeIndex = null;
    _this.latestStartTime = null; // listGroupStyle: object = {
    //   cursor: this.locked ? 'initial' : 'move'
    // };

    _this.searchFilters = ['shipmentReference'];
    _this.searchFilter = 'shipmentReference';
    _this.searchText = '';
    _this.truckStartTime = null;
    _this.currentPlanId = null;
    _this.popperOptions = {
      boundariesElement: 'body',
      gpuAcceleration: false
    };
    _this.sectionTitleHeight = 0;
    _this.sectionUtilitiesHeight = 0;
    _this.sectionFunctionHeight = 0;
    _this.targetTruck = null;
    _this.targetPlanId = null;
    _this.isShowTransferPlanModal = false;
    return _this;
  }

  (0, _createClass2.default)(LMDTruckSummaryComponent, [{
    key: "onRoutesChanges",
    value: function onRoutesChanges(newVal) {
      this.truckInPlan = this.getTruckInPlan(this.$selectedTruck);

      if (newVal.length > 0 && this.truckInPlan) {
        if (!this.$isMobile) {
          this.isReorderingEnabled = !this.truckInPlan['locked'];
        }

        this.latestStartTime = newVal[0]['startTime'];
      }
    }
  }, {
    key: "onSortableChanges",
    value: function onSortableChanges(newVal) {
      this.locked = !newVal; // mixins
      // this.dragOptions['disabled'] = newVal;
      // hack
      // if (newVal) {
      //   this.listGroupStyle['cursor'] = 'initial';
      // }
    }
  }, {
    key: "onTargetTruckChange",
    value: function onTargetTruckChange(newVal) {
      this.targetPlanId = null;
    }
  }, {
    key: "onSelectedTruckChanges",
    value: function onSelectedTruckChanges(newVal) {
      if (newVal) {
        this.targetTruck = null;
        this.searchText = '';
        this.currentTruck = this.helper.cloneDeep(this.currTruck);
        var driverId = this.currentTruck['drivers'].length > 0 ? this.currentTruck['drivers'][0]['id'] : null;

        if (this.routes.length === 0) {
          this.currentPlanId = null;
          this.currentDriver = driverId;
          this.$selectedDriver = this.currentDriver;
          return;
        } // this.truckInPlan = this.getTruckInPlan(newVal);
        // if (this.truckInPlan) {
        //   const driverIds = this.truckInPlan['driverId'];
        //   driverId = driverIds[driverIds.length - 1];
        //   this.updateCurrentPlanId();
        //   this.updateCurrentDriverId();
        // }
        //
        // this.currentDriver = driverId;
        // this.$selectedDriver = this.currentDriver;


        this.truckStartTime = this.routes[0] && this.routes[0]['startTime'] ? this.routes[0]['startTime'] : null;
      } else {
        this.currentTruck = {};
        this.currentDriver = null;
        this.currentPlanId = null;
        this.searchText = '';
      }
    }
  }, {
    key: "onTruckPlanIdsChanges",
    value: function onTruckPlanIdsChanges(newVal, oldVal) {
      // hacked for some reason old and new are the same
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.updateCurrentPlanId();
      }
    }
  }, {
    key: "onCurrentPlanIdChanges",
    value: function onCurrentPlanIdChanges(newVal) {
      if (this.sectionTitleHeight === 0 || this.sectionUtilitiesHeight === 0 || this.sectionFunctionHeight) {
        this.handleSectionHeight();
      } // hacked


      if (newVal === '0') {
        this.currentPlanId = null;
      }

      if (!this.helper.isUndefined(newVal)) {
        this.updateCurrentDriverId();
      }

      this.$emit('onCurrentPlanIdChanges', newVal);
    }
  }, {
    key: "onSelectedPlanIdChanges",
    value: function onSelectedPlanIdChanges(newVal) {
      if (!this.helper.isUndefined(newVal)) {
        this.currentPlanId = newVal;
      }

      this.$emit('onCurrentPlanIdChanges', newVal);
    }
    /*get filteredRoutes(): Array<object> {
      const finalWaypoint: Array<any> = [];
         this.routes.forEach((route) => {
        if (this.helper.isNotEmpty(this.searchText)) {
          if (route && route[this.searchFilter]) {
            if (typeof route[this.searchFilter] === 'string') {
              if (route[this.searchFilter].toString().trim().toLowerCase().includes(this.searchText.trim().toLowerCase())) {
                finalWaypoint.push(route);
              }
            } else {
              if (route[this.searchFilter].find((item) => item.toString().trim().toLowerCase().includes(this.searchText.trim().toLowerCase()))) {
                finalWaypoint.push(route);
              }
            }
          }
        } else {
          finalWaypoint.push(route);
        }
      });
         return finalWaypoint;
    }*/

    /*get defaultDriversList(): Array<number> {
      const truckWithDrivers = this.helper.filter(this.$trucks, truck => truck['drivers'].length > 0) || [];
      return truckWithDrivers.length > 0 ? this.helper.map(truckWithDrivers, truck => truck['drivers'][0]['id']) : [];
    }*/

  }, {
    key: "isDriverSelectionDisabled",
    get: function get() {
      if (this.routes.length === 0) {
        return false;
      } // const selectedRoutes = this.routes.filter(route => route['planId'] === this.currentPlanId);
      // return selectedRoutes.length > 0 ? this.helper.some(selectedRoutes, item => item['status'] === 'assigned' || item['status'] === 'completed') : false;
      // return selectedRoutes.length > 0 ? this.helper.some(selectedRoutes, item => item['status'] === 'completed') : false;


      return false;
    }
  }, {
    key: "isAssignDriverDisabled",
    get: function get() {
      // const selectedRoutes = this.routes.filter(route => route['planId'] === this.currentPlanId);
      // const bool = selectedRoutes.length > 0 ? this.helper.some(selectedRoutes, item => item['status'] === 'assigned') : false;
      return this.routes.length === 0 || // bool ||
      // this.helper.every(this.routes, item => item['status'] !== 'unassigned') ||
      this.helper.isUndefined(this.$selectedDriver) || this.helper.isUndefined(this.currentPlanId);
    }
  }, {
    key: "isCalculateETADisabled",
    get: function get() {
      return this.routes.length === 0; // return this.routes.length === 0 || this.helper.some(this.routes, item => item['status'] === 'assigned');
    }
  }, {
    key: "isTransferLoadPlanEnabled",
    get: function get() {
      var _this2 = this;

      // if no truck and target truck selected
      return !( // Empty Truck
      this.targetTruck && this.getTruckPlanIdsByTruckId(this.targetTruck).length === 0 && !this.isPlanIdBelongToDifferentUser(this.currentPlanId) && !this.helper.some(this.getRoutes(this.$selectedTruck).filter(function (r) {
        return r['planId'] === _this2.currentPlanId;
      }), function (route) {
        return route.status === 'arrived' || route.status === 'completed';
      }) || // Existing Truck
      this.targetTruck && this.getTruckPlanIdsByTruckId(this.targetTruck).length > 0 && !this.helper.isUndefined(this.targetPlanId) && this.getRoutes(this.targetTruck).length > 0 && !this.isPlanIdBelongToDifferentUser(this.currentPlanId) && !this.isPlanIdBelongToDifferentUser(this.targetPlanId, this.targetTruck) && !this.helper.some(this.getRoutes(this.targetTruck).filter(function (r) {
        return r['planId'] === _this2.targetPlanId;
      }), function (route) {
        return route.status === 'assigned' || route.status === 'arrived' || route.status === 'completed';
      }));
    }
  }, {
    key: "isTransferLoadPlanDisabled",
    get: function get() {
      var _this3 = this;

      // if no truck and target truck selected
      if (!this.$selectedTruck || !this.currentPlanId || !this.targetTruck) {
        return true;
      }

      if (this.isPlanIdBelongToDifferentUser(this.currentPlanId)) {
        return true;
      }

      var truckIndex = this.helper.findIndex(this.$plan.trucks, function (truck) {
        return truck['truckId'] === _this3.$selectedTruck;
      });
      var selectedAssigned = false;

      if (truckIndex >= 0) {
        var truckObj = this.$plan.trucks[truckIndex];

        if (truckObj['routes'].find(function (tData) {
          return tData['planId'] === _this3.currentPlanId && (tData['status'] === 'arrived' || tData['status'] === 'completed');
        })) {
          return true;
        }

        if (truckObj['routes'].find(function (tData) {
          return tData['planId'] === _this3.currentPlanId && tData['status'] === 'assigned';
        })) {
          selectedAssigned = true;
        }
      }

      var truckTargetIndex = this.helper.findIndex(this.$plan.trucks, function (truck) {
        return truck['truckId'] === _this3.targetTruck;
      });

      if (truckTargetIndex >= 0) {
        var truckTargetObj = this.$plan.trucks[truckTargetIndex];

        if (selectedAssigned) {
          if (truckTargetObj['planId'].length >= 1) {
            return true;
          }
        } else {
          // if has planid and taget planid is empty
          if (truckTargetObj['planId'].length >= 1) {
            if (!this.targetPlanId) {
              return true;
            } // if target with plan is not unassigned


            if (truckTargetObj['routes'] && truckTargetObj['routes'].length >= 1 && truckTargetObj['routes'].find(function (tData) {
              return tData['planId'] === _this3.targetPlanId && (tData['status'] === 'assigned' || tData['status'] === 'arrived' || tData['status'] === 'completed');
            })) {
              return true;
            } // if disabled plan id


            if (this.isPlanIdBelongToDifferentUser(this.targetPlanId, this.targetTruck)) {
              return true;
            }
          }
        }
      }

      return false;
    }
  }, {
    key: "listHeight",
    get: function get() {
      // return '100%';
      var height = this.truckSummaryHeight - 8 - this.sectionTitleHeight - this.sectionUtilitiesHeight - this.sectionFunctionHeight - (this.isPlanIdBelongToDifferentUser(this.currentPlanId) ? 29 : 0);
      return "".concat(height, "px");
    }
  }, {
    key: "containerHeight",
    get: function get() {
      return {
        height: "".concat(this.truckSummaryHeight, "px")
      };
    }
  }, {
    key: "isComponentDisabled",
    value: function isComponentDisabled() {
      var isPlanIdSelectionDisabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var isPlanIdBelongToDifferentUser = this.isPlanIdBelongToDifferentUser(this.currentPlanId);

      if (isPlanIdSelectionDisabled) {
        isPlanIdBelongToDifferentUser = false;
      }

      return this.helper.isUndefined(this.$selectedTruck) || this.truckPlanIds && (this.truckPlanIds.length === 0 || this.currentPlanId === null) || this.isManualAssignLoading || this.isAutoAssignLoading || isPlanIdBelongToDifferentUser;
    }
  }, {
    key: "isUnassignBtnDisabled",
    get: function get() {
      var _this4 = this;

      if (this.helper.isUndefined(this.currentPlanId)) {
        return true;
      }

      var bufferRoutes = this.routes.filter(function (r) {
        return r['planId'] === _this4.currentPlanId;
      });

      if (this.helper.isUndefined(bufferRoutes) && !bufferRoutes.length) {
        return true;
      }

      return this.isPlanIdRoutesAllUnassigned || this.isPlanIdRoutesSomeCompleted;
    }
  }, {
    key: "isPlanIdRoutesAllUnassigned",
    get: function get() {
      var _this5 = this;

      var bufferRoutes = this.routes.filter(function (r) {
        return r['planId'] === _this5.currentPlanId;
      });

      if (this.helper.isUndefined(bufferRoutes) && !bufferRoutes.length) {
        return false;
      }

      return this.helper.every(bufferRoutes, function (i) {
        return i.status.toUpperCase() === 'UNASSIGNED';
      });
    }
  }, {
    key: "isPlanIdRoutesSomeCompleted",
    get: function get() {
      var _this6 = this;

      var bufferRoutes = this.routes.filter(function (r) {
        return r['planId'] === _this6.currentPlanId;
      });

      if (this.helper.isUndefined(bufferRoutes) && !bufferRoutes.length) {
        return false;
      }

      return this.helper.some(bufferRoutes, function (i) {
        return i.status.toUpperCase() === 'COMPLETED';
      });
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      window.removeEventListener('resize', this.handleSectionHeight);
    }
  }, {
    key: "created",
    value: function created() {
      window.addEventListener('resize', this.handleSectionHeight);

      if (this.$isMobile) {
        this.isReorderingEnabled = false;
      }
    }
  }, {
    key: "handleCurrentDriverChanges",
    value: function handleCurrentDriverChanges() {
      var _this7 = this;

      var isTrueAnyChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.routes.length > 0) {
        var bufferRoutes = this.helper.cloneDeep(this.routes);
        this.helper.forEach(bufferRoutes, function (item) {
          if (item.planId === _this7.currentPlanId) {
            item['driverId'] = _this7.currentDriver;
          }
        });
        this.routes = bufferRoutes;
        var plan = this.helper.cloneDeep(this.$plan);
        var truckIndex = this.helper.findIndex(plan['trucks'], function (truck) {
          return truck['truckId'] === _this7.$selectedTruck;
        });

        if (truckIndex !== -1) {
          this.$anyChanges = isTrueAnyChanges;
          plan['trucks'][truckIndex]['driverId'] = this.helper.uniq(bufferRoutes.map(function (route) {
            return route.driverId;
          }).filter(function (driverId) {
            return !_this7.helper.isUndefined(driverId);
          }));
          this.$setPlan({
            'plan': plan
          });
          var selectedRoutes = this.routes.filter(function (route) {
            return route['planId'] === _this7.currentPlanId;
          });

          if (this.helper.some(selectedRoutes, function (item) {
            return item['status'].toUpperCase() === 'ASSIGNED';
          })) {
            this.$isAssignedDriverChanges = true;
          }
        }
      }

      this.$selectedDriver = this.currentDriver;
    }
    /*isDriverDisabled(driverId: number): boolean {
      const trucks = this.$plan.trucks;
      let planDriverIds = [];
      let defaultDriverIds = this.defaultDriversList;
      if (trucks.length > 0) {
        planDriverIds = this.helper.map(trucks, 'driverId');
           const truckIds = this.helper.map(trucks, 'truckId');
        const truckWithDrivers = this.helper.filter(this.$trucks, truck => truck['drivers'].length > 0 && !this.helper.includes(truckIds, truck.id)) || [];
        defaultDriverIds = truckWithDrivers.length > 0 ? this.helper.map(truckWithDrivers, truck => truck['drivers'][0]['id']) : [];
      }
      const driverIds = [...defaultDriverIds, ...planDriverIds];
         return this.helper.includes(driverIds, driverId);
    }*/

  }, {
    key: "handleRouteChanges",
    value: function () {
      var _handleRouteChanges = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        var oldIndex, newIndex;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                /*const route = e.moved.element;
                const oldIndex = e.moved.oldIndex;
                const newIndex = e.moved.newIndex;
                const index = route['waypointType'] === 'P' ? newIndex - 1 : newIndex + 1;
                const waypointType = route['waypointType'] === 'P' ? 'D' : 'P';
                const buffer = this.helper.cloneDeep(this.routes);
                     if (this.routes[0]['waypointType'] !== 'P') {
                  buffer.splice(newIndex, 1);
                  buffer.splice(oldIndex, 0, route);
                  this.routes = buffer;
                       const message: ElNotificationOptions = {
                    title: this.$i18n.t('planning.messages.pickUpFirst'),
                    duration: 5000
                  } as ElNotificationOptions;
                  Notification.warning(message);
                } else {
                  this.routeIndex = (newIndex < oldIndex) ? newIndex : oldIndex;
                  await this.updateETA('REORDER');
                }*/
                oldIndex = e.moved.oldIndex;
                newIndex = e.moved.newIndex;
                this.routeIndex = newIndex < oldIndex ? newIndex : oldIndex;
                _context.next = 5;
                return this.updateETA('REORDER');

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleRouteChanges(_x) {
        return _handleRouteChanges.apply(this, arguments);
      }

      return handleRouteChanges;
    }()
  }, {
    key: "onRouteClick",
    value: function onRouteClick(index) {
      var buffer = this.helper.cloneDeep(this.routes);
      this.helper.forEach(buffer, function (item, idx) {
        item['isHighlighted'] = idx === index;
      });
      this.routes = buffer;
    }
  }, {
    key: "openRouteDetails",
    value: function openRouteDetails(index, route) {
      if (!this.isRouteBelongToDifferentUser(route)) {
        this.routeDetails = this.routes[index];
        this.routeIndex = index;
        this.isModalVisible = true;
      }
    }
  }, {
    key: "updateRouteDetails",
    value: function () {
      var _updateRouteDetails = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
        var index, routeForm, startTime, buffer, calculateEta;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$anyChanges = true;
                index = e['index'];
                routeForm = e['routeForm']; // const startTime = moment(routeForm['startTime']).format('YYYY-MM-DD HH:mm:00');

                startTime = routeForm['convertedStartTime'] ? routeForm['convertedStartTime'] : routeForm['startTime'];
                this.latestStartTime = startTime;
                buffer = this.helper.cloneDeep(this.routes);
                buffer[index].locked = routeForm.locked;
                buffer[index].startTime = startTime;
                buffer[index].waitingTime = routeForm.waitingTime;
                buffer[index].handlingTime = routeForm.handlingTime;
                _context2.next = 12;
                return this.calculateETA({
                  routes: buffer,
                  startTime: startTime,
                  index: index,
                  isLocked: routeForm.locked
                });

              case 12:
                calculateEta = _context2.sent;

                if (calculateEta) {
                  this.updateCurrentTruck(calculateEta);

                  if ((0, _moment.default)(routeForm['startTime']).format('YYYY-MM-DD') !== this.$planDate) {
                    this.$emit('onRecalculateTimeList', _moment.default.duration((0, _moment.default)(routeForm['startTime']).diff(this.$planDate, 'days'), 'days').asDays());
                  } // Insert log


                  this.insertLogs('update route', {
                    routeType: 'last-mile-delivery',
                    planDate: this.$planDate,
                    truckId: this.$selectedTruck,
                    routes: buffer,
                    route: buffer[index],
                    routeIndex: index,
                    startTime: startTime,
                    routeForm: routeForm,
                    user: this.$userInformation.user,
                    globalUsers: this.$GLOBAL_ACTIVE_USERS
                  });
                }

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateRouteDetails(_x2) {
        return _updateRouteDetails.apply(this, arguments);
      }

      return updateRouteDetails;
    }()
  }, {
    key: "updateModalVisibility",
    value: function updateModalVisibility(value) {
      this.isModalVisible = value;
    }
  }, {
    key: "updateETA",
    value: function () {
      var _updateETA = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(type) {
        var payload, calculateEta;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                payload = {
                  routes: this.helper.cloneDeep(this.routes),
                  startTime: this.latestStartTime,
                  index: 0
                };

                if (type === 'REORDER') {
                  payload = {
                    routes: this.helper.cloneDeep(this.routes),
                    startTime: null,
                    index: this.routeIndex >= 1 ? this.routeIndex - 1 : this.routeIndex
                  };
                }

                _context3.next = 4;
                return this.calculateETA(payload, type);

              case 4:
                calculateEta = _context3.sent;

                if (calculateEta) {
                  this.updateCurrentTruck(calculateEta);
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function updateETA(_x3) {
        return _updateETA.apply(this, arguments);
      }

      return updateETA;
    }()
  }, {
    key: "assignToDriver",
    value: function () {
      var _assignToDriver = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this8 = this;

        var plan, truckIndex, payload, carPlate, orderIds, orderShipRefs, assignDriverResponse, isAssignSuccessful, invalidOrders, message;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                plan = this.helper.cloneDeep(this.$plan);
                truckIndex = this.helper.findIndex(plan.trucks, function (truck) {
                  return truck['truckId'] === _this8.$selectedTruck;
                });

                if (!(truckIndex !== -1)) {
                  _context4.next = 26;
                  break;
                }

                plan['trucks'][truckIndex]['routes'].forEach(function (route) {
                  if (route.planId === _this8.currentPlanId && route.status.toUpperCase() !== 'COMPLETED') {
                    route.status = 'assigned';
                  }
                });
                payload = [];
                carPlate = this.getCarPlateFromDriverId(this.currentDriver);
                orderIds = this.helper.uniq(this.helper.flatten(plan.trucks[truckIndex].routes.filter(function (route) {
                  return route.planId === _this8.currentPlanId;
                }).map(function (route) {
                  return route.orderId;
                })));
                orderShipRefs = this.getShipRefsFromOrderId(orderIds);

                if (this.helper.isUndefined(carPlate)) {
                  _context4.next = 26;
                  break;
                }

                this.helper.forEach(orderShipRefs, function (order) {
                  payload.push({
                    shipref: order,
                    drivercode: carPlate,
                    truckrecid: plan.trucks[truckIndex].truckId
                  });
                });

                if (!payload.length) {
                  _context4.next = 26;
                  break;
                }

                _context4.next = 13;
                return this.assignDriver(payload);

              case 13:
                assignDriverResponse = _context4.sent;
                isAssignSuccessful = assignDriverResponse['isSuccess'];
                invalidOrders = assignDriverResponse['invalidOrders'];
                message = {
                  title: this.$i18n.t('planning.messages.assignOrderSuccess'),
                  duration: 5000
                };

                if (!isAssignSuccessful) {
                  _context4.next = 24;
                  break;
                }

                _elementUi.Notification.success(message);

                this.$isAssignedDriverChanges = false;
                _context4.next = 22;
                return this.savePlan(plan);

              case 22:
                _context4.next = 26;
                break;

              case 24:
                message['message'] = "".concat(this.$i18n.t('planning.messages.assigningFailedBecause'), " ").concat(invalidOrders, " ").concat(this.$i18n.t('planning.messages.cantBeAssigned'));

                _elementUi.Notification.error(message);

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function assignToDriver() {
        return _assignToDriver.apply(this, arguments);
      }

      return assignToDriver;
    }()
  }, {
    key: "printPlanId",
    value: function () {
      var _printPlanId = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this9 = this;

        var payload, res, status, message, url;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.currentPlanId) {
                  _context5.next = 16;
                  break;
                }

                payload = [{
                  planId: this.currentPlanId,
                  truckId: this.truckInPlan['truckId'],
                  driverId: this.truckInPlan['driverId'],
                  orderId: this.helper.uniq(this.helper.flatten(this.truckInPlan['routes'].filter(function (route) {
                    return route.planId === _this9.currentPlanId;
                  }).map(function (route) {
                    return route.orderId;
                  }))),
                  routes: this.truckInPlan['routes'].filter(function (route) {
                    return route.planId === _this9.currentPlanId;
                  })
                }];
                _context5.next = 4;
                return this.planAPI.printPlanId(payload);

              case 4:
                res = _context5.sent;
                status = this.helper.get(res, 'data.status', 300);
                message = {
                  title: this.$i18n.t('planning.messages.printPlanSuccess'),
                  duration: 5000
                };

                if (!(!res || res['failed'] || status === 'error' || status === 'error header')) {
                  _context5.next = 11;
                  break;
                }

                message['message'] = "".concat(this.$i18n.t('planning.messages.printPlanFailed'));

                _elementUi.Notification.error(message);

                return _context5.abrupt("return", false);

              case 11:
                url = this.helper.get(res, 'data.url', null);

                if (this.helper.isUndefined(url)) {
                  _context5.next = 16;
                  break;
                }

                _elementUi.Notification.success(message);

                window.open(url, '_blank');
                return _context5.abrupt("return", true);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function printPlanId() {
        return _printPlanId.apply(this, arguments);
      }

      return printPlanId;
    }()
  }, {
    key: "isRouteEarlyLate",
    value: function isRouteEarlyLate(route) {
      var orderId = parseInt(route.masterpointId.split('-')[0], 10) || null;
      var waypointIndex = parseInt(route.masterpointId.split('-')[1], 10) || null;
      var eta = route.estimateTime;

      if (orderId && waypointIndex) {
        var order = this.$plan['orders'].filter(function (o) {
          return o['id'] === orderId;
        });

        if (!order || order.length === 0) {
          return '';
        }

        var waypoint = order[0].waypoints[waypointIndex - 1];

        if (!waypoint || waypoint.length === 0) {
          return '';
        }

        var startDuration = _moment.default.duration(route.timeWindow[0], 'seconds').as('milliseconds');

        var startTime = _moment.default.utc(startDuration).format('HH:mm:ss');

        startTime = (0, _moment.default)(waypoint.startTime).format("YYYY-MM-DD ".concat(startTime));

        var endDuration = _moment.default.duration(route.timeWindow[1], 'seconds').as('milliseconds');

        var endTime = _moment.default.utc(endDuration).format('HH:mm:ss');

        endTime = (0, _moment.default)(waypoint.startTime).format("YYYY-MM-DD ".concat(endTime));

        if (endTime.substring(11, 19) === '00:00:00') {
          endTime = (0, _moment.default)(endTime).format('YYYY-MM-DD 23:59:59');
        }

        return (0, _moment.default)(eta).diff(endTime) > 0 || (0, _moment.default)(eta).diff(startTime) < 0;
      }

      return false;
    }
  }, {
    key: "isRouteLate",
    value: function isRouteLate(route) {
      var runningTime = route.runningTime ? Number(route.runningTime) : 0;
      var timeWindow = route.timeWindow.length === 2 ? route.timeWindow : [0, 0];
      var bool1 = runningTime >= Number(timeWindow[0]) && runningTime <= Number(timeWindow[1]);
      return !bool1 || this.isRouteEarlyLate(route) ? 'route-late' : '';
    }
    /*isRouteLate(route) {
      const runningTime = route.runningTime ? Number(route.runningTime) : 0;
      const timeWindow = route.timeWindow.length === 2 ? route.timeWindow : [0, 0];
      const buffer = this.$userSetting.default13 ? Number(this.$userSetting.default13) : 0;
         if (runningTime >= (Number(timeWindow[0]) - buffer) && runningTime <= (Number(timeWindow[1]) + buffer)) {}
         const orderId = parseInt(route.masterpointId.split('-')[0], 10) || null;
      const waypointIndex = parseInt(route.masterpointId.split('-')[1], 10) || null;
      const eta = route.estimateTime;
         if (orderId && waypointIndex) {
        const order = this.$plan['orders'].filter(o => o['id'] === orderId);
        if (!order || order.length === 0) {
          return '';
        }
           const waypoint = order[0].waypoints[waypointIndex - 1];
        if (!waypoint || waypoint.length === 0) {
          return '';
        }
           let endTime = waypoint.endTime;
        if (endTime.substring(11, 19) === '00:00:00') {
          endTime = moment(endTime).format('YYYY-MM-DD 23:59:59');
        }
           return moment(eta).diff(endTime) > 0 ? 'route-late' : '';
      }
         return '';
    }*/

  }, {
    key: "getRouteStyles",
    value: function getRouteStyles(route) {
      var _this10 = this;

      var isOverwriteCursor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var bool = false;
      var bool2 = route.planId === this.currentPlanId;
      var bool3 = this.truckPlanIds.length > 0 && this.helper.isUndefined(this.currentPlanId);

      if (this.helper.isNotEmpty(this.searchText)) {
        if (route && route[this.searchFilter]) {
          bool = typeof route[this.searchFilter] === 'string' ? route[this.searchFilter].toString().trim().toLowerCase().includes(this.searchText.trim().toLowerCase()) : route[this.searchFilter].find(function (item) {
            return item.toString().trim().toLowerCase().includes(_this10.searchText.trim().toLowerCase());
          });
        }
      } else {
        bool = true;
      }

      var cursorStyle = !this.isReorderingEnabled || this.isPlanIdBelongToDifferentUser(this.currentPlanId) || route.locked || route.status.toUpperCase() === 'COMPLETED' ? 'initial' : 'move';

      if (isOverwriteCursor) {
        cursorStyle = 'initial';
      }

      return {
        cursor: cursorStyle,
        display: bool && bool2 || bool3 ? 'block' : 'none'
      };
    }
  }, {
    key: "getTargetRouteStyles",
    value: function getTargetRouteStyles(route) {
      var bool2 = route.planId === this.targetPlanId;
      var bool3 = this.getTruckPlanIdsByTruckId(this.targetTruck).length > 0 && this.helper.isUndefined(this.targetPlanId);
      return {
        cursor: 'initial',
        display: bool2 || bool3 ? 'block' : 'none'
      };
    }
  }, {
    key: "getRouteClass",
    value: function getRouteClass(route) {
      var _this11 = this;

      var isRouteLast = false;
      var bufferRoutes = this.routes.filter(function (r) {
        return r['planId'] === _this11.currentPlanId;
      });

      if (bufferRoutes.length > 0) {
        isRouteLast = bufferRoutes[bufferRoutes.length - 1]['code'] === route['code'];
      }

      return (0, _defineProperty2.default)({
        'last-child': isRouteLast,
        'disabled': route.locked || route.status.toUpperCase() === 'COMPLETED'
      }, route.status, true);
    }
  }, {
    key: "getTargetRouteClass",
    value: function getTargetRouteClass(route) {
      var _this12 = this;

      var isRouteLast = false;
      var bufferRoutes = this.getRoutes(this.targetTruck).filter(function (r) {
        return r['planId'] === _this12.targetPlanId;
      });

      if (bufferRoutes.length > 0) {
        isRouteLast = bufferRoutes[bufferRoutes.length - 1]['code'] === route['code'];
      }

      return (0, _defineProperty2.default)({
        'last-child': isRouteLast,
        'disabled': route.locked || route.status === 'completed'
      }, route.status, true);
    }
  }, {
    key: "updateCurrentPlanId",
    value: function updateCurrentPlanId() {
      var _this13 = this;

      if (this.truckInPlan && this.truckInPlan['planId']) {
        var truckPlanIds = this.truckInPlan['planId'];
        var index = truckPlanIds.findIndex(function (planId) {
          return planId === _this13.selectedPlanId;
        });
        this.currentPlanId = index !== -1 ? this.selectedPlanId || null : truckPlanIds.length > 0 ? truckPlanIds[truckPlanIds.length - 1] : null;
        this.$emit('onCurrentPlanIdChanges', this.currentPlanId);
      }
    }
  }, {
    key: "updateCurrentDriverId",
    value: function updateCurrentDriverId() {
      var _this14 = this;

      var driverId = this.currentTruck['drivers'].length > 0 ? this.currentTruck['drivers'][0]['id'] : null;

      if (this.truckInPlan && this.truckInPlan['routes']) {
        var matchedRoute = this.truckInPlan['routes'].find(function (route) {
          return route.planId === _this14.currentPlanId;
        });
        /*if (!this.helper.isUndefined(matchedRoute) && !this.helper.isUndefined(matchedRoute['driverId'])) {
          driverId = matchedRoute['driverId'];
        }*/

        if (matchedRoute) {
          driverId = matchedRoute['driverId'];
        }
      } // if (this.helper.isUndefined(this.currentDriver)) {


      this.currentDriver = driverId;
      this.$selectedDriver = this.currentDriver; // }

      /*if (this.truckInPlan && this.truckInPlan['routes'] && !this.helper.isUndefined(driverId)) {
        this.handleCurrentDriverChanges(false);
      }*/
    }
  }, {
    key: "handleSectionHeight",
    value: function handleSectionHeight() {
      var _this15 = this;

      this.$nextTick(function () {
        _this15.sectionTitleHeight = _this15.helper.get(document.getElementById('sectionTitle'), 'offsetHeight', 0);
        _this15.sectionUtilitiesHeight = _this15.helper.get(document.getElementById('sectionUtilities'), 'offsetHeight', 0);
        _this15.sectionFunctionHeight = _this15.helper.get(document.getElementById('sectionFunction'), 'offsetHeight', 0);
      });
    }
  }, {
    key: "getUsername",
    value: function getUsername() {
      var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.routes;
      var planId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.currentPlanId;
      return this.helper.get(routes.filter(function (r) {
        return r['planId'] === planId;
      }), '0.user', this.$userInformation.user.name);
    }
  }, {
    key: "getTimeWindow",
    value: function getTimeWindow(timeWindow) {
      var duration = _moment.default.duration(timeWindow, 'seconds').as('milliseconds');

      return _moment.default.utc(duration).format('HH:mm');
    }
  }, {
    key: "getOrderId",
    value: function getOrderId(route) {
      return parseInt(route.masterpointId.split('-')[0], 10) || null;
    }
  }, {
    key: "handleTransferLoadPlan",
    value: function handleTransferLoadPlan() {
      this.searchText = '';
      this.isShowTransferPlanModal = true;
    }
  }, {
    key: "transferLoadPlan",
    value: function () {
      var _transferLoadPlan = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this16 = this;

        var isTransferToEmptyTruckWithPlanId, bufferPlan, truckIndex, truckObj, fRoutesByPlanId, orderIds, shipRefs, unassignedOrders, res, prefix, newPlanIds, newPlanId, driverId, currentData, _prefix, _newPlanIds, _newPlanId, fRoutes;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.isShowTransferPlanModal = false;

                if (!this.helper.isUndefined(this.currentPlanId)) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return", false);

              case 3:
                isTransferToEmptyTruckWithPlanId = this.targetTruck && this.targetPlanId;
                bufferPlan = this.helper.cloneDeep(this.$plan);
                truckIndex = this.helper.findIndex(bufferPlan.trucks, function (truck) {
                  return truck['truckId'] === _this16.$selectedTruck;
                });
                truckObj = bufferPlan.trucks[truckIndex];
                fRoutesByPlanId = truckObj.routes.filter(function (r) {
                  return r['planId'] === _this16.currentPlanId;
                });
                orderIds = this.helper.uniq(this.helper.flatten(fRoutesByPlanId.map(function (r) {
                  return r['orderId'];
                })));
                shipRefs = bufferPlan.orders.filter(function (o) {
                  return orderIds.includes(o.id);
                }).map(function (o) {
                  return o.shipmentReference;
                });
                unassignedOrders = bufferPlan.orders.filter(function (o) {
                  return orderIds.includes(o.id);
                });
                res = null;

                if (!truckObj['routes'].find(function (tData) {
                  return tData['planId'] === _this16.currentPlanId && tData['status'] === 'assigned';
                })) {
                  _context6.next = 30;
                  break;
                }

                // const date = moment(this.$planDate).format('YYMMDD');
                prefix = this.helper.generateNewPlanId(this.$userData.planIdFormat, this.$planDate, this.$userInformation, 'lastmile');
                _context6.next = 16;
                return this.routeAPI.generateLoadPlanId(prefix, 1);

              case 16:
                newPlanIds = _context6.sent;
                newPlanId = this.helper.get(newPlanIds, 'data.0', []);
                driverId = truckObj['driverId'].length >= 1 ? truckObj['driverId'][0] : '';
                currentData = {
                  'planId': this.currentPlanId,
                  'routePlanIdCount': fRoutesByPlanId.length,
                  'routeCount': truckObj.routes.length,
                  'truckId': this.$selectedTruck,
                  'shipmentReference': shipRefs
                };
                _context6.next = 22;
                return this.handleAssignedTruckObj({
                  planId: newPlanId,
                  truckId: this.targetTruck,
                  unassignedOrders: unassignedOrders,
                  currentData: currentData,
                  driverId: driverId
                });

              case 22:
                res = _context6.sent;
                this.currentPlanId = null;
                this.$selectedTruck = null;

                if (!this.helper.isUndefined(res)) {
                  _context6.next = 27;
                  break;
                }

                return _context6.abrupt("return", false);

              case 27:
                this.$emit('onFailedOrders', res);
                _context6.next = 50;
                break;

              case 30:
                if (!isTransferToEmptyTruckWithPlanId) {
                  _context6.next = 35;
                  break;
                }

                _context6.next = 33;
                return this.handleExistingTruckObj({
                  planId: this.targetPlanId,
                  truckObj: this.getTruckInPlan(this.targetTruck),
                  unassignedOrders: unassignedOrders
                });

              case 33:
                _context6.next = 42;
                break;

              case 35:
                // const date = moment(this.$planDate).format('YYMMDD');
                // const prefix = this.helper.generatePlanId(date, this.$userInformation.company.name);
                _prefix = this.helper.generateNewPlanId(this.$userData.planIdFormat, this.$planDate, this.$userInformation, 'lastmile');
                _context6.next = 38;
                return this.routeAPI.generateLoadPlanId(_prefix, 1);

              case 38:
                _newPlanIds = _context6.sent;
                _newPlanId = this.helper.get(_newPlanIds, 'data.0', []);
                _context6.next = 42;
                return this.handleNewTruckObj({
                  planId: _newPlanId,
                  truckId: this.targetTruck,
                  unassignedOrders: unassignedOrders
                });

              case 42:
                bufferPlan = this.helper.cloneDeep(this.$plan); // Update data for current truck
                // Transfer the whole cargo

                if (truckObj.routes.length === fRoutesByPlanId.length) {
                  bufferPlan.trucks.splice(truckIndex, 1);
                } else {
                  fRoutes = truckObj.routes.filter(function (r) {
                    return r['planId'] !== _this16.currentPlanId;
                  }); // fRoutes[0]['time'] = 0;

                  /*const startDates = fRoutes.map(d => moment(d.startTime));
                  const endDates = fRoutes.map(d => moment(d.endTime));
                  const earliestStartDate = moment.min(startDates);
                  const latestEndDate = moment.max(endDates);
                  truckObj.estimatedTime = moment.duration(latestEndDate.diff(earliestStartDate, 'seconds'), 'seconds').asSeconds();*/

                  truckObj.driverId = this.helper.uniq(fRoutes.map(function (r) {
                    return r['driverId'];
                  }));
                  truckObj.estimatedDistance = this.helper.sumBy(fRoutes, 'distance');
                  truckObj.estimatedTime = this.helper.sumBy(fRoutes, 'time');
                  truckObj.orderId = truckObj.orderId.filter(function (o) {
                    return !orderIds.includes(o);
                  });
                  truckObj.shipmentReference = truckObj.shipmentReference.filter(function (o) {
                    return !shipRefs.includes(o);
                  });
                  truckObj.planId = truckObj.planId.filter(function (i) {
                    return i !== _this16.currentPlanId;
                  });
                  truckObj.routes = fRoutes;
                  bufferPlan.trucks[truckIndex] = truckObj;
                }

                bufferPlan.planId = bufferPlan.planId.filter(function (id) {
                  return id !== _this16.currentPlanId;
                });
                this.$setPlan({
                  'plan': bufferPlan
                });
                this.$selectedTruck = this.targetTruck;
                this.targetTruck = null;
                this.targetPlanId = null;
                this.$anyChanges = true;

              case 50:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function transferLoadPlan() {
        return _transferLoadPlan.apply(this, arguments);
      }

      return transferLoadPlan;
    }()
  }, {
    key: "handleLoadPlanModalClose",
    value: function handleLoadPlanModalClose() {
      this.targetTruck = null;
      this.targetPlanId = null;
    }
    /*
    isTruckHasRoutes(truckId): boolean {
      const truck = this.getTruckInPlan(truckId);
      if (this.helper.isUndefined(truck)) {
        return false;
      }
         return truck['routes'].length !== 0;
    }
       async transferAllLoadPlans() {
      if (this.truckPlanIds.length === 0) {
        return false;
      }
         this.$anyChanges = true;
         const targetTruckObj = this.getTruckInfo(this.targetTruck);
      const index = this.helper.findIndex(this.$plan.trucks, t => t['truckId'] === targetTruckObj['id']);
         if (index !== -1) {
        await this.transferPlansToNonEmptyTruck(targetTruckObj);
      } else {
        this.transferPlansToEmptyTruck(targetTruckObj);
      }
    }
       async transferPlansToNonEmptyTruck(targetTruckObj) {}
       transferPlansToEmptyTruck(targetTruckObj) {
      const bufferPlan = this.helper.cloneDeep(this.$plan);
      const truckIndex = this.helper.findIndex(this.$plan.trucks, t => t['truckId'] === this.$selectedTruck);
         const truck = this.helper.cloneDeep(this.currPlanTruck);
      truck.truckId = targetTruckObj['id'];
      truck.plateNumber = targetTruckObj['plateNumber'];
      // truck.workingHours = targetTruckObj['workingHours'];
         bufferPlan.trucks.splice(truckIndex, 1);
      bufferPlan.trucks.push(truck);
      this.$setPlan({ 'plan': bufferPlan });
         this.$selectedTruck = this.targetTruck;
    }*/

  }, {
    key: "unassignPlanId",
    value: function () {
      var _unassignPlanId = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _this17 = this;

        var bufferRoutes, orderIds, orderShipRefs, payload, res, message, bufferR;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                bufferRoutes = this.routes.filter(function (r) {
                  return r['planId'] === _this17.currentPlanId;
                });

                if (!(this.helper.isUndefined(bufferRoutes) && !bufferRoutes.length)) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt("return");

              case 3:
                orderIds = this.helper.uniq(this.helper.flatten(bufferRoutes.map(function (r) {
                  return r['orderId'];
                })));
                orderShipRefs = this.getShipRefsFromOrderId(orderIds);
                payload = [];
                this.helper.forEach(orderShipRefs, function (order) {
                  payload.push({
                    shipref: order
                  });
                });
                _context7.next = 9;
                return this.cancelDriverAssignment(payload);

              case 9:
                res = _context7.sent;

                if (res) {
                  _context7.next = 14;
                  break;
                }

                message = {
                  title: this.$i18n.t('planning.messages.unassignFailed'),
                  duration: 5000
                };

                _elementUi.Notification.warning(message);

                return _context7.abrupt("return");

              case 14:
                bufferR = this.helper.cloneDeep(this.routes);
                bufferR.forEach(function (r) {
                  if (r['planId'] === _this17.currentPlanId) {
                    r['status'] = 'unassigned';
                  }
                });
                this.routes = bufferR;
                _context7.next = 19;
                return this.savePlan(this.$plan);

              case 19:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function unassignPlanId() {
        return _unassignPlanId.apply(this, arguments);
      }

      return unassignPlanId;
    }()
  }, {
    key: "handleFailedOrders",
    value: function handleFailedOrders(res) {
      this.$emit('onFailedOrders', res);
    }
  }, {
    key: "handleSearchShipRef",
    value: function handleSearchShipRef(val) {
      var _this18 = this;

      var route = this.routes.find(function (r) {
        return typeof r[_this18.searchFilter] === 'string' ? r[_this18.searchFilter].toString().trim().toLowerCase().includes(val.trim().toLowerCase()) : r[_this18.searchFilter].find(function (item) {
          return item.toString().trim().toLowerCase().includes(val.trim().toLowerCase());
        });
      });

      if (!this.helper.isUndefined(route) && route['planId'] !== this.currentPlanId) {
        this.currentPlanId = route['planId'];
      }
    }
  }, {
    key: "getStartAndEndTime",
    value: function getStartAndEndTime() {
      var waypointIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (waypointIds.length >= 1) {
        var startTime = this.getWaypointFromId(waypointIds[0], 'startTime');
        var endTime = this.getWaypointFromId(waypointIds[0], 'endTime');
        var stTime = startTime && startTime.split(' ').length === 2 ? startTime.split(' ')[1] : '00:00:00';
        var etTime = endTime && endTime.split(' ').length === 2 ? endTime.split(' ')[1] : '23:59:00';
        return "".concat(stTime.substring(0, 5), " - ").concat(etTime.substring(0, 5)); // const wpSplit: string = waypointIds[0].split('-');
        // const order = this.$plan['orders'].find(o => o['id'] === Number(wpSplit[0]));
        // if (!this.helper.isEmptyObject(order)) {
        //   const orderWp = order['waypoints'].find(oWp => oWp['id'] === waypointIds[0]);
        //   if (!this.helper.isEmptyObject(orderWp)) {
        //     const stTime: string = (orderWp['startTime'] && orderWp['startTime'].split(' ').length === 2) ? orderWp['startTime'].split(' ')[1] : '00:00:00';
        //     const etTime: string = (orderWp['endTime'] && orderWp['endTime'].split(' ').length === 2) ? orderWp['endTime'].split(' ')[1] : '23:59:00';
        //     return `${stTime.substring(0, 5)} - ${etTime.substring(0, 5)}`;
        //   }
        // }
      }

      return '00:00 - 23:59';
    }
  }]);
  return LMDTruckSummaryComponent;
}((0, _vuePropertyDecorator.Mixins)(_lastMileDelivery.LastMileDeliveryMixin));

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], LMDTruckSummaryComponent.prototype, "isAutoAssign", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: 'manual'
})], LMDTruckSummaryComponent.prototype, "type", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 1191
})], LMDTruckSummaryComponent.prototype, "truckSummaryHeight", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: null
})], LMDTruckSummaryComponent.prototype, "selectedPlanId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('routes', {
  deep: true
})], LMDTruckSummaryComponent.prototype, "onRoutesChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('isReorderingEnabled', {
  immediate: true
})], LMDTruckSummaryComponent.prototype, "onSortableChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('targetTruck')], LMDTruckSummaryComponent.prototype, "onTargetTruckChange", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$selectedTruck')], LMDTruckSummaryComponent.prototype, "onSelectedTruckChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('truckPlanIds')], LMDTruckSummaryComponent.prototype, "onTruckPlanIdsChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('currentPlanId')], LMDTruckSummaryComponent.prototype, "onCurrentPlanIdChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('selectedPlanId')], LMDTruckSummaryComponent.prototype, "onSelectedPlanIdChanges", null);
LMDTruckSummaryComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDTruckSummaryComponent',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-button': _elementUi.Button,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-switch': _elementUi.Switch,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'draggable': _vuedraggable.default,
    'truck-summary-modal': _truckSummaryModal.default,
    'el-tooltip': _elementUi.Tooltip,
    'el-input': _elementUi.Input,
    'el-tabs': _elementUi.Tabs,
    'el-tab-pane': _elementUi.TabPane,
    'el-dialog': _elementUi.Dialog
  }
})], LMDTruckSummaryComponent);
var _default = LMDTruckSummaryComponent;
exports.default = _default;